import { PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE } from 'emma-common-ts/emma';

export const audienceKpiTypeLabels = {
  [PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE.IMPACTS]: $localize`Impactados`,
  [PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE.CONVERSIONS]: $localize`Conversiones`,
};

export const audienceKpiTypeOptions = [
  {
    value: PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE.IMPACTS,
    label: audienceKpiTypeLabels[PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE.IMPACTS],
    icon: 'la-eye',
  },
  {
    value: PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE.CONVERSIONS,
    label: audienceKpiTypeLabels[PERFORMANCE_REPORT_AUDIENCE_KPI_TYPE.CONVERSIONS],
    icon: 'la-hand-pointer',
  },
];
